import React from 'react';
import { Alert, Button } from 'react-bootstrap';

export function relatedPermissions(tabs, selected) {
    const known = new Map(tabs.map(tab => [tab.tabKey, tab]));
    const result = new Set(selected);
    const visit = key => (known.get(key)?.dependencies || []).forEach(required => {
        if (known.has(required) && !result.has(required)) { result.add(required); visit(required); }
    });
    selected.forEach(visit);
    return [...result];
}

export default function HospitalarPermissionEditor({ tabs, selected, enabled, onChange, onInclude }) {
    const titles = Object.fromEntries(tabs.map(tab => [tab.tabKey, tab.tabTitle]));
    const related = relatedPermissions(tabs, selected);
    const missing = related.filter(key => !selected.includes(key));
    const groups = tabs.reduce((all, tab) => {
        const group = tab.group || 'Outros acessos hospitalares';
        (all[group] ||= []).push(tab);
        return all;
    }, {});
    return <div style={{marginTop:12}}>
        <Alert variant="info" className="py-2 small">As permissões estão organizadas por área. Os acessos relacionados completam a navegação e a operação do fluxo. Nenhuma permissão é adicionada automaticamente. Setor, Cargo, Especialidade e vínculo à unidade continuam sendo verificados.</Alert>
        {enabled && missing.length > 0 && <Alert variant="warning" role="status">
            <strong>Há combinações incompletas neste perfil.</strong>
            <p className="small mb-2">Confira os acessos relacionados ainda desmarcados:</p>
            <ul className="small">{missing.map(key => <li key={key}>{titles[key]}</li>)}</ul>
            <Button size="sm" variant="outline-dark" type="button" onClick={() => onInclude(related)}>Incluir permissões relacionadas</Button>
            <p className="small mt-2 mb-0">Revise o alcance antes de salvar: essas permissões também liberam suas funções nos demais caminhos do sistema.</p>
        </Alert>}
        {Object.entries(groups).map(([name, entries]) => <section key={name} className="border rounded p-3 mb-3" aria-label={name}>
            <h6 className="mb-3">{name}</h6>
            {entries.map(tab => {
                const checked = enabled && selected.includes(tab.tabKey);
                const dependencies = tab.dependencies || [];
                return <div key={tab.tabKey} className="mb-3">
                    <label className="d-flex align-items-start gap-2" style={{cursor:enabled?'pointer':'not-allowed'}}>
                        <input type="checkbox" className="perm-checkbox mt-1" checked={checked} disabled={!enabled} onChange={event => onChange(tab.tabKey,event.target.checked)} />
                        <span style={{fontSize:12,color:checked?'#374151':'#6b7280'}}>{tab.tabTitle}</span>
                    </label>
                    {dependencies.length > 0 && <div className="small ms-4 mt-1 text-muted">Para completar este fluxo: {dependencies.map(key => <span key={key} className="d-block">{enabled && selected.includes(key) ? '✓' : '○'} {titles[key] || key}</span>)}</div>}
                    {tab.permission_note && <p className="small text-muted ms-4 mt-1 mb-0">{tab.permission_note}</p>}
                </div>;
            })}
        </section>)}
    </div>;
}
